import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { setSessionToken } from '../fetchInterceptor';
import { Loader2 } from 'lucide-react';

export default function ImpersonateStart() {
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get('token');
    if (token) {
      setSessionToken(token);
      window.location.replace('/dashboard');
    } else {
      window.location.replace('/');
    }
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-200" data-testid="impersonate-start-page">
      <div className="flex items-center gap-3 text-sm">
        <Loader2 className="h-5 w-5 animate-spin text-amber-400" />
        Starting admin session…
      </div>
    </div>
  );
}
